export const getTrimmedPhoneNumber = (phoneNumber) =>
  String(phoneNumber ?? '').trim();

export const getPhoneNumberDigits = (phoneNumber) =>
  getTrimmedPhoneNumber(phoneNumber).replace(/\D/g, '');
